import BrandPage from './modules/brand/BrandPage.svelte';

const app = new BrandPage({
	target: document.getElementById("brand-page"),
	props: {
		
	}
});

export default app;